import { round } from 'lodash';
import FormatMixin from '../../../../Application/mixins/FormatMixin';

const { valorReal } = FormatMixin.methods;

export const productTabInformationToEdit = (
  productOfPurchaseOnFiscalEdit,
  decimalConfiguration,
) => {
  const { productData } = productOfPurchaseOnFiscalEdit;
  const { quantity } = decimalConfiguration;

  return {
    productData: {
      ...productData,
      quantityPurchased: valorReal(round(productData.quantityPurchased, quantity), quantity),
      discount: productData.vDesc,
    },
  };
};

export const fiscalValuesToEdit = (productOfPurchaseOnFiscalEdit) => {
  const { values } = productOfPurchaseOnFiscalEdit.fiscal;

  return {
    values: {
      ...values,
      pIPI: valorReal(values.pIPI, 4),
      pPIS: valorReal(values.pPIS, 4),
      pCOFINS: valorReal(values.pCOFINS, 4),
      pICMS: valorReal(values.pICMS, 4),
      pICMSST: valorReal(values.pICMSST, 4),
      pST: valorReal(values.pST, 4),
      pMVAST: valorReal(values.pMVAST, 4),
      pFCPST: valorReal(values.pFCPST, 4),
      cst: values.cst ?? null,
      cfop: values.cfop ?? null,
      csosn: values.csosn ?? null,
      cstIpi: values.cstIpi ?? null,
      cenq: values.cenq ?? null,
      cstPis: values.cstPis ?? null,
      cstCofins: values.cstCofins ?? null,
      origem: values.origem ?? null,
    },
  };
};

export const inventoryProductFiscalInformation = (productInventoryFiscal) => ({
  values: {
    cfop: productInventoryFiscal.CFOP,
    origem: productInventoryFiscal.origem,
    cst: productInventoryFiscal.CST,
    csosn: productInventoryFiscal.CSOSN,
    cstIpi: productInventoryFiscal.CSTIPI,
    cenq: productInventoryFiscal.CENQ,
    cstPis: productInventoryFiscal.CSTPIS,
    cstCofins: productInventoryFiscal.CSTCOFINS,
  },
  ids: {
    cfopId: productInventoryFiscal.CFOP?.id,
    ncmId: productInventoryFiscal.NCM?.id,
    cenqId: productInventoryFiscal.CENQ?.id,
    cestId: productInventoryFiscal.CEST?.id,
    origemId: productInventoryFiscal.origem?.id,
    cstId: productInventoryFiscal.CST?.id,
    anpId: productInventoryFiscal.ANP?.id,
    csosnId: productInventoryFiscal.CSOSN?.id,
    cstIPIId: productInventoryFiscal.CSTIPI?.id,
    cstPISId: productInventoryFiscal.CSTPIS?.id,
    cstCOFINSId: productInventoryFiscal.CSTCOFINS?.id,
  },
});
